import { P2TextLabel } from 'react-bootstrap-common-script';
interface ShareCoverProps {
  hpsCoverage: string | number;
}

const ShareCover: React.FC<ShareCoverProps> = ({ hpsCoverage }) => {
  return (
    <div className='polymer-stage-e_step-3_part-a_wrapper'>
      <div className='polymer-stage-e_step-3_part-a_title'>
        <P2TextLabel bold={700} label={'Share cover'} fontSize={'18px'} lineHeight={'24px'} />
      </div>
      <div className='polymer-stage-e_step-3_part-a_label'>
        <P2TextLabel bold={400} label={`${hpsCoverage}%`} fontSize={'18px'} lineHeight={'24px'} />
      </div>
    </div>
  );
};

export default ShareCover;
